import * as Sentry from '@sentry/browser';
import { ErrorHandler, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '~env/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class SentryErrorHandler implements ErrorHandler {
  constructor(
    @Inject(PLATFORM_ID)
    private readonly platformId: Object,
  ) {
    if (isPlatformBrowser(platformId) && environment.sentryDsn()) {
      const ignoreErrors = [
        'exponea is not defined',
        'this._drag.stage.start',
        'Non-Error exception captured with keys: invalidParams, sourceError',
        'Cannot read properties of null',
        'Non-Error exception captured with keys'
      ];

      Sentry.init({
        dsn: environment.sentryDsn(),
        environment: environment.appEnv() || 'development',
        release: environment.sentryRelease() || 'web-app-buyer@r000000',
        ignoreErrors,
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,

        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration(),
        ],

        allowUrls: [
          /checkout\//,
          /auth\//,
          /account\//,
        ],
      });
    }
  }

  handleError(error) {
    if (!isPlatformBrowser(this.platformId) || !environment.sentryDsn()) {
      // Skip errors when we don't have proper env dns url for Sentry
      return;
    }

    // Ignore sending of cors issues to Sentry
    if (error && error.sourceError instanceof HttpErrorResponse && error.sourceError.status === 0) {
      return;
    }

    Sentry.captureException(error.originalError || error.error || error);
  }
}
